import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Plus, RefreshCw } from 'lucide-react';

import styled from 'styled-components';

import {
    PageActions,
    PageActionsMenu,
    PageBreadcrumb,
    PageBreadcrumbSegment,
    PageHeader,
    type PageActionGroup,
} from 'components/PageHeader';
import { OrganizationsList } from './components/OrganizationsList';
import { SyncInvoiceBoostsPopup } from './Popups/SyncInvoiceBoostsPopup';
import { TotadminPermission } from 'data/__generated__';

export const Organizations = () => {
    const [isSyncInvoiceBoostsOpen, setIsSyncInvoiceBoostsOpen] = useState(false);

    const actionGroups: PageActionGroup[] = [
        {
            items: [
                {
                    label: 'Ajouter une organisation',
                    icon: <Plus />,
                    to: '/organization/create',
                    dataTest: 'create-organization',
                    requiredPermissions: [TotadminPermission.OrganizationsManage],
                },
                {
                    label: 'Synchroniser le fichier de boost',
                    icon: <RefreshCw />,
                    onClick: () => setIsSyncInvoiceBoostsOpen(true),
                    dataTest: 'sync-invoice-boosts',
                    requiredPermissions: [TotadminPermission.InvoicesManage],
                },
            ],
        },
    ];

    return (
        <Container>
            <Helmet title="Organisations · TOTADMIN" />
            <PageHeader>
                <PageBreadcrumb>
                    <PageBreadcrumbSegment label="Organisations" isCurrent />
                </PageBreadcrumb>
                <PageActions>
                    <PageActionsMenu groups={actionGroups} />
                </PageActions>
            </PageHeader>
            <Content>
                <ListContainer>
                    <OrganizationsList />
                </ListContainer>
            </Content>
            <SyncInvoiceBoostsPopup isOpen={isSyncInvoiceBoostsOpen} setIsOpen={setIsSyncInvoiceBoostsOpen} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
